// extracted by mini-css-extract-plugin
module.exports =  {"settingsCard":"jut__SettingsCard__settingsCard","settingsCardContainer":"jut__SettingsCard__settingsCardContainer","settingsCardContent":"jut__SettingsCard__settingsCardContent"};